module.exports = __webpack_public_path__ + "img/single-post-img3-200x132.ecb484f9.jpg";